import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './header';
import Sidebar from './sidebar';
import Login from './login';
import NotFound from './NotFound';
import ResetPassword from './ResetPassword';

import MachineManagement from './MachineManagement';
import MachineInfo from './MachineInfo';
import MachineCreate from './MachineCreate';
import FRFX from './FRFX';
import FRFY from './FRFY';
import FRFZ from './FRFZ';
import VFRFX from './VFRFX';
import VFRFY from './VFRFY';
import VFRFZ from './VFRFZ';
import SFRFX from './SFRFX';
import SFRFY from './SFRFY';
import SFRFZ from './SFRFZ';
import GradingX from './GradingX';
import GradingY from './GradingY';
import GradingZ from './GradingZ';

import AssembleManagement from './AssembleManagement';
import AssembleInfo from './AssembleInfo';
import AssembleCreate from './AssembleCreate';
import AssembleFRFX from './AssembleFRFX';
import AssembleFRFY from './AssembleFRFY';
import AssembleFRFZ from './AssembleFRFZ';
import AssembleVFRFX from './AssembleVFRFX';
import AssembleVFRFY from './AssembleVFRFY';
import AssembleVFRFZ from './AssembleVFRFZ';
import AssembleSFRFX from './AssembleSFRFX';
import AssembleSFRFY from './AssembleSFRFY';
import AssembleSFRFZ from './AssembleSFRFZ';
import AssembleGradingX from './AssembleGradingX';
import AssembleGradingY from './AssembleGradingY';
import AssembleGradingZ from './AssembleGradingZ';

import CastingManagement from './CastingManagement';
import CastingInfo from './CastingInfo';
import CastingCreate from './CastingCreate';
import CastingFRF from './CastingFRF';
import CastingSFRF from './CastingSFRF';
import CastingVFRF from './CastingVFRF';
import CastingGrade from './CastingGrade';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'normalize.css';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleLogin = (userData) => {
    setIsLoggedIn(true);
    localStorage.setItem('isLoggedIn', 'true');
    localStorage.setItem('username', userData.username);
    localStorage.setItem('department', userData.department);
    localStorage.setItem('role', userData.role);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    localStorage.removeItem('isLoggedIn');
  };

  useEffect(() => {
    const storedLoginState = localStorage.getItem('isLoggedIn');
    if (storedLoginState === 'true') {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  return (
    <Router>
      <div className={`App ${isLoggedIn ? 'no-background' : 'background'}`}>

        <div className="d-flex flex-column">
          {!isLoggedIn &&
            <Routes>
              <Route path="/login" element={<Login onLogin={handleLogin} />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="*" element={<Login onLogin={handleLogin} />} />
            </Routes>}

          {isLoggedIn && (
            <>
              <Routes>
                <Route path="/" element={<Navigate to="/machine-management" replace />} />
                <Route path="*" element={<NotFound />} />
                <Route
                  path="/machine-management"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <MachineManagement />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/machine-info/:id"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <MachineInfo />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/machine-create"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <MachineCreate />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/frequency-response-function/x"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <FRFX />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/frequency-response-function/y"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <FRFY />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/frequency-response-function/z"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <FRFZ />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/view-frequency-response-function/x"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <VFRFX />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/view-frequency-response-function/y"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <VFRFY />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/view-frequency-response-function/z"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <VFRFZ />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/solo-frequency-response-function-x/:id"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <SFRFX />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/solo-frequency-response-function-y/:id"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <SFRFY />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/solo-frequency-response-function-z/:id"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <SFRFZ />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/grading-frequency-response-function/x"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <GradingX />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/grading-frequency-response-function/y"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <GradingY />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/grading-frequency-response-function/z"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <GradingZ />
                        </main>
                      </div>
                    </>
                  }
                />




                <Route
                  path="/assemble-management"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <AssembleManagement />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/assemble-info/:id"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <AssembleInfo />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/assemble-create"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <AssembleCreate />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/assemble-frequency-response-function/x"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <AssembleFRFX />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/assemble-frequency-response-function/y"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <AssembleFRFY />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/assemble-frequency-response-function/z"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <AssembleFRFZ />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/assemble-view-frequency-response-function/x"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <AssembleVFRFX />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/assemble-view-frequency-response-function/y"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <AssembleVFRFY />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/assemble-view-frequency-response-function/z"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <AssembleVFRFZ />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/assemble-solo-frequency-response-function-x/:id"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <AssembleSFRFX />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/assemble-solo-frequency-response-function-y/:id"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <AssembleSFRFY />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/assemble-solo-frequency-response-function-z/:id"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <AssembleSFRFZ />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/assemble-grading-frequency-response-function/x"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <AssembleGradingX />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/assemble-grading-frequency-response-function/y"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <AssembleGradingY />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/assemble-grading-frequency-response-function/z"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <AssembleGradingZ />
                        </main>
                      </div>
                    </>
                  }
                />





                <Route
                  path="/casting-management"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <CastingManagement />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/casting-info/:id"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <CastingInfo />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/casting-create"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <CastingCreate />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/casting-frequency-response-function"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <CastingFRF />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/casting-solo-frequency-response-function/:id"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <CastingSFRF />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/casting-view-frequency-response-function"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <CastingVFRF />
                        </main>
                      </div>
                    </>
                  }
                />
                <Route
                  path="/casting-grade"
                  element={
                    <>
                      <Header onLogout={handleLogout} isLoggedIn={isLoggedIn} />
                      <div className="d-flex">
                        <Sidebar />
                        <main className="flex-grow-1 scroll-bar">
                          <CastingGrade />
                        </main>
                      </div>
                    </>
                  }
                />
              </Routes>
            </>
          )}
        </div>
      </div>
    </Router>
  );
}

export default App;